import { LevelSetQuestion } from '../questionTypes';

export const levelSetQuestion: LevelSetQuestion = {
  id: "level-set",
  type: "level-set",
  title: "Let's set the foundation for your succession planning journey",
  description: "Understanding these key areas will help us provide you with the most relevant insights and next steps.",
  required: false,
  sections: [
    {
      icon: "chat",
      title: "Goal",
      content: "Gain awareness of strengths and growth areas in your succession planning readiness. This assessment identifies key opportunities to enhance your transition strategy and build confidence in your succession plan."
    },
    {
      icon: "lightbulb", 
      title: "Research",
      content: "Studies show that business owners who complete formal succession assessments are 65% more likely to achieve their desired transition outcomes. Early planning and systematic evaluation significantly improve both financial results and personal satisfaction with the succession process."
    },
    {
      icon: "info",
      title: "How it works",
      content: "• Answer questions to the best of your ability there are no right or wrong answers\n• Receive immediate insights about your current readiness\n• Your mySuccession score looks at your answers and calculations your specific next steps\n• Access resources tailored to your unique transition journey"
    }
  ],
  buttonText: "Continue to Assessment"
};